import { createFileRoute } from '@tanstack/react-router';
import { ReportRunnerPage } from '@/features/analytics-reporting/ReportRunnerPage';

export const Route = createFileRoute('/_dashboard/dashboard/reporting/reports/$reportId')({
  component: AnalyticsReportPage,
  validateSearch: (
    search,
  ): {
    range?: string;
    from?: string;
    to?: string;
    sourceCustomer?: string;
    collectionAmount?: string;
    collectionBucket?: string;
    collectionDueDate?: string;
    collectionDaysOverdue?: string;
    collectionAsOf?: string;
    collectionReportId?: string;
  } => ({
    range: typeof search.range === 'string' ? search.range : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
    sourceCustomer: typeof search.sourceCustomer === 'string' ? search.sourceCustomer : undefined,
    collectionAmount:
      typeof search.collectionAmount === 'string' ? search.collectionAmount : undefined,
    collectionBucket:
      typeof search.collectionBucket === 'string' ? search.collectionBucket : undefined,
    collectionDueDate:
      typeof search.collectionDueDate === 'string' ? search.collectionDueDate : undefined,
    collectionDaysOverdue:
      typeof search.collectionDaysOverdue === 'string' ? search.collectionDaysOverdue : undefined,
    collectionAsOf: typeof search.collectionAsOf === 'string' ? search.collectionAsOf : undefined,
    collectionReportId:
      typeof search.collectionReportId === 'string' ? search.collectionReportId : undefined,
  }),
});

function AnalyticsReportPage() {
  const { reportId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <ReportRunnerPage
      reportId={reportId}
      collectionContext={
        search.sourceCustomer
          ? {
              customerName: search.sourceCustomer,
              amount: search.collectionAmount,
              bucket: search.collectionBucket,
              dueDate: search.collectionDueDate,
              daysOverdue: search.collectionDaysOverdue,
              asOf: search.collectionAsOf,
              reportId: search.collectionReportId,
            }
          : undefined
      }
    />
  );
}
